export type MediaType = "movie" | "tv" | "variety";

export interface MediaItem {
  id: string;
  title: string;
  type: MediaType;
  year: string;
  region: string;
  rating: number;
  heat: number;
  genres: string[];
  cast: string[];
  director: string;
  synopsis: string;
  image: string;
}

export const MEDIA_TYPE_LABEL: Record<MediaType, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};

export const mediaList: MediaItem[] = [
  {
    id: "m1",
    title: "深空回响",
    type: "movie",
    year: "2025",
    region: "中国大陆",
    rating: 8.7,
    heat: 9860,
    genres: ["科幻", "剧情"],
    cast: ["陈砚舟", "林知夏", "周牧云"],
    director: "顾承宇",
    synopsis:
      "一支深空探测队在木星轨道收到一段来历不明的重复信号。随着解码推进，队长发现信号竟与十年前失踪的同伴有关，而真相将彻底改写人类对宇宙的认知。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20a%20lone%20deep%20space%20astronaut%20facing%20a%20giant%20glowing%20planet%2C%20dramatic%20moody%20lighting%2C%20rich%20vibrant%20orange%20and%20teal%20palette%2C%20atmospheric%20depth%2C%20ultra%20detailed%20digital%20painting%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-m1&orientation=portrait",
  },
  {
    id: "m2",
    title: "长安旧梦",
    type: "movie",
    year: "2024",
    region: "中国大陆",
    rating: 8.9,
    heat: 9720,
    genres: ["历史", "剧情"],
    cast: ["宋之衡", "苏映雪", "陆谦和"],
    director: "叶清和",
    synopsis:
      "盛唐末年，一位失意的画师受命修复一幅残缺的宫廷画卷，却在颜料之下发现了牵动朝局的秘密。一卷画，一座城，一段被尘封的往事缓缓展开。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20ancient%20Chinese%20Tang%20dynasty%20palace%20under%20amber%20sunset%2C%20warm%20golden%20orange%20hues%2C%20elegant%20ink%20painting%20texture%2C%20dramatic%20atmospheric%20light%2C%20ultra%20detailed%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-m2&orientation=portrait",
  },
  {
    id: "m3",
    title: "逆光而行",
    type: "movie",
    year: "2025",
    region: "中国大陆",
    rating: 8.2,
    heat: 8340,
    genres: ["剧情"],
    cast: ["何未然", "江雨桐", "许卓"],
    director: "罗清扬",
    synopsis:
      "一名不甘平凡的小镇青年在城市打拼多年后遭遇人生低谷，却因一次意外的支教经历重新找回了前行的勇气。一部关于坚持与自我救赎的暖心之作。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20a%20young%20man%20standing%20at%20a%20city%20crossing%20at%20dawn%20silhouette%20against%20warm%20golden%20sunlight%2C%20hopeful%20mood%20rich%20orange%20tones%2C%20soft%20glow%2C%20ultra%20detailed%20digital%20painting%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-m3&orientation=portrait",
  },
  {
    id: "m4",
    title: "暗夜猎手",
    type: "movie",
    year: "2025",
    region: "中国大陆",
    rating: 7.9,
    heat: 7980,
    genres: ["动作", "悬疑"],
    cast: ["楚怀安", "白晴", "孟长歌"],
    director: "穆云笙",
    synopsis:
      "退役特工被迫重返地下世界，为洗清不白之冤而追查一桩连环案件。霓虹闪烁的都市暗流涌动，猎手与猎物之间的边界正变得模糊。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20a%20hooded%20vigilante%20on%20a%20rainy%20neon%20city%20rooftop%20at%20night%2C%20moody%20orange%20and%20deep%20shadow%20lighting%2C%20gritty%20atmospheric%20thriller%2C%20ultra%20detailed%20ink%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-m4&orientation=portrait",
  },
  {
    id: "m5",
    title: "夏日信笺",
    type: "movie",
    year: "2024",
    region: "中国大陆",
    rating: 8.0,
    heat: 7620,
    genres: ["爱情", "剧情"],
    cast: ["温如昨", "余清欢", "沈砚"],
    director: "简宁",
    synopsis:
      "海边小镇的邮局里，两封被错拿的信让两个陌生人的夏天交织在一起。青涩、遗憾与重逢，构成了这个夏天最温柔的注脚。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20two%20young%20people%20on%20a%20sunny%20seaside%20road%20in%20summer%2C%20warm%20breezy%20nostalgic%20mood%2C%20soft%20peach%20and%20orange%20tones%2C%20dreamy%20bokeh%2C%20ultra%20detailed%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-m5&orientation=portrait",
  },
  {
    id: "m6",
    title: "山海秘语",
    type: "movie",
    year: "2025",
    region: "中国大陆",
    rating: 8.4,
    heat: 9020,
    genres: ["冒险", "科幻"],
    cast: ["谢云棠", "洛其琛", "梁鹿鸣"],
    director: "江照野",
    synopsis:
      "地质学家在一处远古洞穴中发现了违背常理的生物遗迹，人类与神秘山海世界之间的通道似乎正在被悄然打开。一场跨越文明的探险就此启程。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20explorers%20before%20a%20colossal%20mystic%20mountain%20cavern%20with%20glowing%20amber%20crystals%2C%20epic%20adventure%20atmosphere%2C%20warm%20orange%20and%20teal%20palette%2C%20ultra%20detailed%20digital%20painting%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-m6&orientation=portrait",
  },
  {
    id: "m7",
    title: "都市浮生",
    type: "movie",
    year: "2023",
    region: "中国大陆",
    rating: 7.6,
    heat: 6480,
    genres: ["剧情"],
    cast: ["方既明", "黎晚舟", "钱屿"],
    director: "程一苇",
    synopsis:
      "一个深夜出租车司机与四位陌生乘客的短暂相遇，串起了这座城市里普通人的悲欢。平淡之中，藏着最真实的生活重量。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20a%20taxi%20cab%20on%20a%20wet%20city%20street%20at%20night%20with%20warm%20reflections%2C%20melancholic%20urban%20mood%2C%20amber%20orange%20street%20lights%2C%20cinematic%20composition%2C%20ultra%20detailed%20illustration%2C%20no%20text%20no%20letters&width=600&height=900&seq=po18-poster-m7&orientation=portrait",
  },
  {
    id: "m8",
    title: "星际孤旅",
    type: "movie",
    year: "2025",
    region: "中国大陆",
    rating: 8.8,
    heat: 9560,
    genres: ["科幻"],
    cast: ["裴时予", "颜清越", "秦望舒"],
    director: "岳承川",
    synopsis:
      "在漫长的星际迁徙中，唯一的幸存者独自驾驶飞船穿越无垠黑暗，寻找传说中适合人类栖居的新家园。孤独，是宇宙给文明最后的考题。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%2C%20a%20lone%20starship%20drifting%20through%20a%20vast%20orange%20nebula%2C%20immense%20scale%20sense%20of%20wonder%2C%20rich%20warm%20cosmic%20palette%2C%20deep%20atmospheric%20space%2C%20ultra%20detailed%20digital%20painting%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-m8&orientation=portrait",
  },
  {
    id: "m9",
    title: "笑对人生",
    type: "movie",
    year: "2024",
    region: "中国大陆",
    rating: 7.4,
    heat: 5960,
    genres: ["喜剧"],
    cast: ["吴悠", "戴小满", "老白"],
    director: "康乐",
    synopsis:
      "一个屡战屡败的中年创业者和三个不靠谱的伙伴，在一次啼笑皆非的旅途中意外收获了人生的答案。笑中带泪，温暖治愈。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20comedy%20movie%20poster%20key%20art%2C%20three%20cheerful%20friends%20on%20a%20bright%20colorful%20road%20trip%2C%20playful%20upbeat%20mood%2C%20vivid%20orange%20and%20yellow%20palette%2C%20clean%20flat%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-m9&orientation=portrait",
  },
  {
    id: "m10",
    title: "无声证词",
    type: "movie",
    year: "2025",
    region: "中国大陆",
    rating: 8.6,
    heat: 9240,
    genres: ["悬疑"],
    cast: ["商云澈", "谭思予", "温砚秋"],
    director: "谢无咎",
    synopsis:
      "一桩看似平凡的失踪案，因一段没有声音的监控录像变得扑朔迷离。当所有证词都指向同一个方向，真相却藏在被忽略的缝隙里。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20mystery%20movie%20poster%20key%20art%2C%20a%20detective%20examining%20a%20silent%20surveillance%20screen%20in%20a%20dark%20room%2C%20tense%20suspenseful%20mood%2C%20moody%20orange%20rim%20light%20deep%20shadows%2C%20ultra%20detailed%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-m10&orientation=portrait",
  },
  {
    id: "m11",
    title: "岁月长歌",
    type: "movie",
    year: "2023",
    region: "中国大陆",
    rating: 9.0,
    heat: 9480,
    genres: ["历史"],
    cast: ["陆沉舟", "白露川", "顾南枝"],
    director: "叶清和",
    synopsis:
      "一个家族三代人的命运，横跨半个世纪的动荡与变迁。他们用平凡的一生，唱响了一曲关于家国、坚守与传承的岁月长歌。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20epic%20historical%20movie%20poster%20key%20art%2C%20a%20family%20silhouette%20before%20a%20vast%20changing%20landscape%20at%20golden%20sunset%2C%20grand%20emotional%20mood%2C%20warm%20amber%20orange%20tones%2C%20ultra%20detailed%20painting%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-m11&orientation=portrait",
  },
  {
    id: "m12",
    title: "极速边缘",
    type: "movie",
    year: "2025",
    region: "中国大陆",
    rating: 8.1,
    heat: 8760,
    genres: ["动作"],
    cast: ["萧凛", "宋子墨", "安琪拉"],
    director: "雷戈",
    synopsis:
      "天才赛车手因一场事故失去一切，为了夺回荣誉，他重返赛道与宿敌展开一场生死时速的终极较量。速度的尽头，是勇气与信念的燃烧。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20action%20movie%20poster%20key%20art%2C%20a%20racing%20car%20drifting%20on%20a%20night%20circuit%20with%20flying%20sparks%2C%20high%20octane%20energy%2C%20vivid%20orange%20and%20deep%20shadow%20lighting%2C%20ultra%20detailed%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-m12&orientation=portrait",
  },
  {
    id: "t1",
    title: "云端之城",
    type: "tv",
    year: "2025",
    region: "中国大陆",
    rating: 8.3,
    heat: 8520,
    genres: ["都市"],
    cast: ["许云舟", "程知意", "罗屿森"],
    director: "沈砚秋",
    synopsis:
      "在一座快速崛起的科技新城，几位年轻创业者追逐梦想、直面现实。理想与利益、友情与爱情在云端之上激烈碰撞。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20TV%20drama%20poster%20key%20art%2C%20modern%20city%20skyline%20with%20warm%20sunrise%20light%20above%20the%20clouds%2C%20aspirational%20urban%20mood%2C%20warm%20orange%20tones%2C%20clean%20modern%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-t1&orientation=portrait",
  },
  {
    id: "t2",
    title: "宫廷风云",
    type: "tv",
    year: "2024",
    region: "中国大陆",
    rating: 8.7,
    heat: 9180,
    genres: ["历史"],
    cast: ["萧若兰", "慕容彻", "沈昭"],
    director: "燕南归",
    synopsis:
      "深宫之内，一位聪慧的女官凭借过人的智慧在波诡云谲的宫廷斗争中步步为营，既要守护心中道义，又要查明家族蒙冤的真相。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20historical%20palace%20drama%20poster%20key%20art%2C%20elegant%20ancient%20Chinese%20palace%20halls%20in%20warm%20lantern%20light%2C%20regal%20atmospheric%20mood%2C%20rich%20golden%20orange%20palette%2C%20ultra%20detailed%20painting%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-t2&orientation=portrait",
  },
  {
    id: "t3",
    title: "都市情缘",
    type: "tv",
    year: "2025",
    region: "中国大陆",
    rating: 7.8,
    heat: 7240,
    genres: ["爱情", "都市"],
    cast: ["林晚棠", "顾言澈", "夏之禾"],
    director: "温柔",
    synopsis:
      "两个在都市中努力生活的年轻人在一次次阴差阳错的相遇中，从互相看不顺眼到慢慢走进彼此心里。甜而不腻，治愈日常。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20romance%20drama%20poster%20key%20art%2C%20a%20young%20couple%20on%20a%20city%20street%20at%20golden%20hour%20warm%20bokeh%2C%20sweet%20tender%20mood%2C%20soft%20peach%20and%20orange%20tones%2C%20dreamy%20cinematic%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-t3&orientation=portrait",
  },
  {
    id: "t4",
    title: "破晓追凶",
    type: "tv",
    year: "2025",
    region: "中国大陆",
    rating: 8.9,
    heat: 9340,
    genres: ["悬疑"],
    cast: ["秦锋", "苏未晞", "陆征"],
    director: "谢无咎",
    synopsis:
      "一队刑警在破晓时分展开对一桩悬案的追查，随着线索层层剥开，警队内部尘封多年的秘密也逐渐浮出水面。真相越近，危险越近。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20crime%20thriller%20poster%20key%20art%2C%20police%20officers%20in%20a%20dim%20investigation%20room%20with%20evidence%20board%2C%20tense%20gritty%20mood%2C%20moody%20orange%20and%20deep%20shadow%20lighting%2C%20ultra%20detailed%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-t4&orientation=portrait",
  },
  {
    id: "t5",
    title: "青春纪事",
    type: "tv",
    year: "2024",
    region: "中国大陆",
    rating: 8.0,
    heat: 7420,
    genres: ["青春"],
    cast: ["阮晓阳", "苏念", "江辰逸"],
    director: "周予安",
    synopsis:
      "高三教室里的一群少年，在备考的紧张与悸动中度过人生最难忘的一年。关于友情、暗恋与成长，那些被夏天收藏的瞬间永不褪色。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20youth%20drama%20poster%20key%20art%2C%20students%20in%20a%20sunny%20classroom%20with%20dusty%20warm%20light%20rays%2C%20nostalgic%20hopeful%20mood%2C%20soft%20orange%20and%20cream%20tones%2C%20ultra%20detailed%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-t5&orientation=portrait",
  },
  {
    id: "t6",
    title: "商海沉浮",
    type: "tv",
    year: "2023",
    region: "中国大陆",
    rating: 8.4,
    heat: 8180,
    genres: ["职场"],
    cast: ["霍英杰", "黎心怡", "袁博"],
    director: "商亦寒",
    synopsis:
      "白手起家的企业家在商海浮沉数十年，经历背叛、危机与崛起。一部关于野心、抉择与人性的现实题材商业大剧。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20business%20drama%20poster%20key%20art%2C%20a%20confident%20executive%20before%20towering%20glass%20skyscrapers%20at%20sunset%2C%20powerful%20ambitious%20mood%2C%20warm%20orange%20and%20slate%20tones%2C%20ultra%20detailed%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-t6&orientation=portrait",
  },
  {
    id: "t7",
    title: "医者仁心",
    type: "tv",
    year: "2025",
    region: "中国大陆",
    rating: 8.6,
    heat: 8640,
    genres: ["医疗"],
    cast: ["方济时", "苏鹤", "陈默"],
    director: "安景明",
    synopsis:
      "急诊科的日日夜夜，见证了医生们的坚守与抉择。在生死之间，他们用专业与温情守护着每一个普通家庭的希望。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20medical%20drama%20poster%20key%20art%2C%20a%20dedicated%20doctor%20in%20a%20bright%20hospital%20corridor%2C%20warm%20hopeful%20mood%2C%20soft%20orange%20and%20clean%20white%20tones%2C%20ultra%20detailed%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-t7&orientation=portrait",
  },
  {
    id: "t8",
    title: "江湖夜雨",
    type: "tv",
    year: "2024",
    region: "中国大陆",
    rating: 8.8,
    heat: 8960,
    genres: ["武侠"],
    cast: ["沈孤鸿", "叶惊鸿", "白芷"],
    director: "墨长风",
    synopsis:
      "一柄剑，一壶酒，一段江湖恩怨。少年侠客为查明师门血案踏入纷争之地，却发现所谓正邪不过是人心的一念之间。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20wuxia%20martial%20arts%20poster%20key%20art%2C%20a%20swordsman%20on%20a%20bamboo%20cliff%20in%20the%20rain%20at%20dusk%2C%20ethereal%20dramatic%20mood%2C%20rich%20amber%20orange%20and%20ink%20tones%2C%20ultra%20detailed%20painting%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-t8&orientation=portrait",
  },
  {
    id: "t9",
    title: "校园时光",
    type: "tv",
    year: "2024",
    region: "中国大陆",
    rating: 7.7,
    heat: 6880,
    genres: ["青春", "都市"],
    cast: ["夏之然", "简一鸣", "温小满"],
    director: "温柔",
    synopsis:
      "一群大学生在社团、恋爱心事与未来迷茫中走过最灿烂的四年。笑声与眼泪交织的校园时光，是每个人都想回去的地方。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20campus%20youth%20drama%20poster%20key%20art%2C%20students%20under%20a%20golden%20autumn%20tree%20on%20campus%2C%20bright%20cheerful%20mood%2C%20warm%20orange%20and%20green%20tones%2C%20clean%20modern%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-t9&orientation=portrait",
  },
  {
    id: "t10",
    title: "悬案档案",
    type: "tv",
    year: "2025",
    region: "中国大陆",
    rating: 9.1,
    heat: 9620,
    genres: ["悬疑"],
    cast: ["霍沉", "祁明月", "范无咎"],
    director: "谢无咎",
    synopsis:
      "一个专门重启冷案的特别小组，从尘封档案中寻找被时间掩盖的真相。每一个案件背后，都是一段等待被听见的人生。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20mystery%20case%20file%20drama%20poster%20key%20art%2C%20an%20investigator%20reading%20old%20files%20by%20a%20single%20desk%20lamp%2C%20intense%20suspenseful%20mood%2C%20warm%20spotlight%20against%20deep%20shadow%2C%20ultra%20detailed%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-t10&orientation=portrait",
  },
  {
    id: "t11",
    title: "家国天下",
    type: "tv",
    year: "2023",
    region: "中国大陆",
    rating: 8.5,
    heat: 8260,
    genres: ["历史"],
    cast: ["萧承稷", "沈青梧", "陆廷琛"],
    director: "燕南归",
    synopsis:
      "乱世之中，一位心怀天下的谋士辅佐明主平定纷争。权谋、忠诚与牺牲交织，恢弘的史诗画卷缓缓铺展。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20epic%20historical%20war%20drama%20poster%20key%20art%2C%20ancient%20Chinese%20armies%20and%20war%20banners%20at%20sunset%2C%20grand%20solemn%20mood%2C%20warm%20amber%20and%20crimson%20orange%20tones%2C%20ultra%20detailed%20painting%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-t11&orientation=portrait",
  },
  {
    id: "t12",
    title: "迷雾之城",
    type: "tv",
    year: "2025",
    region: "中国大陆",
    rating: 8.2,
    heat: 8060,
    genres: ["悬疑", "都市"],
    cast: ["顾南川", "温以宁", "裴砚"],
    director: "穆云笙",
    synopsis:
      "一场持续数日的大雾笼罩整座城市，接连发生的怪事让人们陷入恐慌。记者联手旧友展开调查，逐渐揭开迷雾背后的惊人真相。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20mystery%20drama%20poster%20key%20art%2C%20a%20misty%20city%20skyline%20with%20warm%20streetlights%20glowing%20through%20thick%20fog%2C%20eerie%20atmospheric%20mood%2C%20orange%20and%20slate%20tones%2C%20ultra%20detailed%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-t12&orientation=portrait",
  },
  {
    id: "v1",
    title: "星光舞台",
    type: "variety",
    year: "2025",
    region: "中国大陆",
    rating: 8.5,
    heat: 8720,
    genres: ["音乐"],
    cast: ["陆星野", "苏梦凡", "陈亦扬"],
    director: "星耀制作组",
    synopsis:
      "一档汇聚新生代歌手的音乐竞演综艺，用最纯粹的舞台展现音乐的魅力。每周都有惊喜合作舞台，点燃全场热情。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20music%20competition%20show%20poster%20key%20art%2C%20a%20singer%20silhouette%20on%20a%20glowing%20spotlight%20stage%2C%20energetic%20vibrant%20mood%2C%20warm%20orange%20and%20gold%20stage%20light%2C%20ultra%20detailed%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-v1&orientation=portrait",
  },
  {
    id: "v2",
    title: "快乐出发",
    type: "variety",
    year: "2025",
    region: "中国大陆",
    rating: 8.1,
    heat: 7680,
    genres: ["旅行"],
    cast: ["何欢", "王大川", "柳青青"],
    director: "晴天工作室",
    synopsis:
      "几位嘉宾组成旅行团，探访那些藏在山川湖海间的小众目的地。一路风景一路欢笑，带你发现旅行的另一种打开方式。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20travel%20variety%20show%20poster%20key%20art%2C%20friends%20on%20a%20scenic%20mountain%20road%20trip%20with%20backpacks%2C%20joyful%20sunny%20mood%2C%20warm%20orange%20and%20sky%20tones%2C%20clean%20vibrant%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-v2&orientation=portrait",
  },
  {
    id: "v3",
    title: "美食奇遇记",
    type: "variety",
    year: "2024",
    region: "中国大陆",
    rating: 8.3,
    heat: 7960,
    genres: ["美食"],
    cast: ["沈宴", "苏小厨", "林味之"],
    director: "味蕾工作室",
    synopsis:
      "跟随美食家寻味中国大江南北，从街边小吃到经典大菜。每一道菜背后都有一段动人的故事，一场关于味道与乡愁的奇遇。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20food%20variety%20show%20poster%20key%20art%2C%20a%20warm%20cozy%20street%20food%20stall%20with%20steaming%20dishes%20at%20dusk%2C%20appetizing%20inviting%20mood%2C%20warm%20orange%20and%20amber%20tones%2C%20ultra%20detailed%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-v3&orientation=portrait",
  },
  {
    id: "v4",
    title: "极限挑战赛",
    type: "variety",
    year: "2025",
    region: "中国大陆",
    rating: 8.7,
    heat: 8980,
    genres: ["竞技"],
    cast: ["雷行", "秦岭", "南星"],
    director: "巅峰制作组",
    synopsis:
      "六位艺人组成两队，在极限环境中完成一系列高难度挑战。体力、智力与团队默契的双重考验，输赢之外更见真情。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20extreme%20challenge%20reality%20show%20poster%20key%20art%2C%20contestants%20climbing%20a%20dramatic%20rock%20formation%2C%20intense%20adrenaline%20mood%2C%20warm%20orange%20sunset%20light%2C%20ultra%20detailed%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-v4&orientation=portrait",
  },
  {
    id: "v5",
    title: "说唱新世代",
    type: "variety",
    year: "2025",
    region: "中国大陆",
    rating: 8.6,
    heat: 8560,
    genres: ["音乐"],
    cast: ["MC 阿岳", "灵儿", "老王"],
    director: "节拍工作室",
    synopsis:
      "来自全国各地的新生代说唱歌手同台竞技，用押韵与节奏表达态度与热爱。真实、热血，唱出属于这个时代的声音。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20hip%20hop%20music%20show%20poster%20key%20art%2C%20a%20rapper%20silhouette%20in%20front%20of%20blazing%20orange%20stage%20lights%20and%20crowd%2C%20urban%20edgy%20mood%2C%20rich%20orange%20and%20dark%20tones%2C%20ultra%20detailed%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-v5&orientation=portrait",
  },
  {
    id: "v6",
    title: "创意市集",
    type: "variety",
    year: "2024",
    region: "中国大陆",
    rating: 7.9,
    heat: 6980,
    genres: ["生活"],
    cast: ["顾小满", "陈列", "朱迪"],
    director: "手作工作室",
    synopsis:
      "一群手作与设计爱好者聚集在周末市集，用创意点亮平凡的日常。看普通物件如何在他们手中焕发新生，温暖又有趣。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20lifestyle%20craft%20market%20show%20poster%20key%20art%2C%20colorful%20handmade%20stalls%20at%20a%20cozy%20weekend%20market%2C%20warm%20creative%20mood%2C%20soft%20orange%20and%20pastel%20tones%2C%20clean%20flat%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-v6&orientation=portrait",
  },
  {
    id: "v7",
    title: "野外生存记",
    type: "variety",
    year: "2024",
    region: "中国大陆",
    rating: 8.0,
    heat: 7320,
    genres: ["竞技"],
    cast: ["荒野老张", "林野", "小虎"],
    director: "荒野工作室",
    synopsis:
      "几位嘉宾被投放到无人荒野，仅凭有限工具完成生存任务。他们要学会生火、觅食与搭建庇护所，在自然中重新认识自己。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20wilderness%20survival%20show%20poster%20key%20art%2C%20adventurers%20around%20a%20campfire%20in%20a%20forest%20at%20dusk%2C%20rugged%20adventurous%20mood%2C%20warm%20orange%20firelight%20and%20green%20tones%2C%20ultra%20detailed%20painting%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-v7&orientation=portrait",
  },
  {
    id: "v8",
    title: "幸福三重奏",
    type: "variety",
    year: "2025",
    region: "中国大陆",
    rating: 8.2,
    heat: 7840,
    genres: ["生活"],
    cast: ["周圆圆", "高扬", "李念安"],
    director: "暖光工作室",
    synopsis:
      "三组家庭在郊外小屋度过温馨日常，展示平凡生活里的小确幸。柴米油盐中的相处之道，藏着幸福最真实的模样。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20lifestyle%20family%20show%20poster%20key%20art%2C%20a%20cozy%20countryside%20cottage%20with%20warm%20window%20light%20at%20evening%2C%20warm%20tender%20mood%2C%20soft%20orange%20and%20cream%20tones%2C%20clean%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-v8&orientation=portrait",
  },
  {
    id: "v9",
    title: "脑力大冲关",
    type: "variety",
    year: "2025",
    region: "中国大陆",
    rating: 8.4,
    heat: 8120,
    genres: ["竞技"],
    cast: ["司马聪", "柯南", "苏小小"],
    director: "智慧工作室",
    synopsis:
      "高智商选手集结闯关，在烧脑谜题与极限博弈中一决高下。每一关都是对逻辑、记忆与心理的终极考验，看高手如何绝地反击。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20quiz%20game%20show%20poster%20key%20art%2C%20contestants%20at%20glowing%20puzzle%20podiums%20under%20dramatic%20light%2C%20tense%20smart%20mood%2C%20vivid%20orange%20and%20teal%20tones%2C%20ultra%20detailed%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-v9&orientation=portrait",
  },
  {
    id: "v10",
    title: "舞蹈风暴",
    type: "variety",
    year: "2024",
    region: "中国大陆",
    rating: 8.8,
    heat: 8840,
    genres: ["舞蹈"],
    cast: ["林舞", "苏曼", "陈锋"],
    director: "律动工作室",
    synopsis:
      "顶尖舞者同台竞演，从民族舞到街舞，用身体讲述故事、释放情感。每一场表演都是一次震撼的视觉与心灵风暴。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20dance%20competition%20show%20poster%20key%20art%2C%20a%20dancer%20mid%20leap%20under%20a%20dramatic%20spotlight%20with%20motion%20trails%2C%20passionate%20artistic%20mood%2C%20warm%20orange%20and%20gold%20tones%2C%20ultra%20detailed%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-v10&orientation=portrait",
  },
  {
    id: "v11",
    title: "喜剧之王",
    type: "variety",
    year: "2025",
    region: "中国大陆",
    rating: 8.1,
    heat: 7680,
    genres: ["喜剧"],
    cast: ["马小乐", "胖虎", "阿珍"],
    director: "欢笑工作室",
    synopsis:
      "新生代喜剧人以生活为素材，用段子与表演传递快乐。犀利又不失温度的幽默，让每一个平凡的日子都值得被笑声点亮。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20comedy%20show%20poster%20key%20art%2C%20a%20standup%20comedian%20under%20a%20warm%20spotlight%20on%20a%20stage%20with%20laughters%2C%20playful%20upbeat%20mood%2C%20vivid%20orange%20and%20yellow%20tones%2C%20clean%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-v11&orientation=portrait",
  },
  {
    id: "v12",
    title: "一路有你",
    type: "variety",
    year: "2025",
    region: "中国大陆",
    rating: 7.8,
    heat: 6720,
    genres: ["旅行"],
    cast: ["许一路", "顾小南", "安然"],
    director: "远行工作室",
    synopsis:
      "素人嘉宾结伴踏上慢旅行，在陌生的城市里交换故事、治愈彼此。旅途中最美的风景，永远是同行的人。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20slow%20travel%20show%20poster%20key%20art%2C%20travelers%20walking%20a%20quiet%20old%20town%20alley%20at%20golden%20dusk%2C%20warm%20wistful%20mood%2C%20soft%20orange%20and%20amber%20tones%2C%20ultra%20detailed%20illustration%2C%20no%20text%20no%20letters%2C%20portrait%20composition&width=600&height=900&seq=po18-poster-v12&orientation=portrait",
  },
];

export const genreMap: Record<MediaType, string[]> = {
  movie: ["动作", "爱情", "喜剧", "科幻", "悬疑", "剧情", "历史", "冒险"],
  tv: ["都市", "历史", "悬疑", "爱情", "青春", "职场", "武侠", "医疗"],
  variety: ["音乐", "旅行", "美食", "竞技", "生活", "舞蹈", "喜剧"],
};

export const categoryIntro: Record<MediaType, { title: string; desc: string }> = {
  movie: {
    title: "电影",
    desc: "聚合院线新片、口碑佳作与类型佳选，从科幻史诗到温情喜剧，帮你快速找到想看的那一部。",
  },
  tv: {
    title: "电视剧",
    desc: "都市、历史、悬疑、武侠一网打尽，追踪热门剧集更新，发现值得熬夜追的好剧。",
  },
  variety: {
    title: "综艺",
    desc: "音乐、旅行、美食、竞技应有尽有，热门季播与新上线节目一网打尽，承包你的下饭时光。",
  },
};

